module.exports = __webpack_public_path__ + "media/images/icons/calendar-6712179170ff2ceccc76160aa346f7e5.svg";